import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ConditionsGeneralesPage() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />

      <section className="pt-36 pb-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <span className="text-xs font-semibold uppercase tracking-widest text-navy-700 mb-4 block">
            Mentions légales
          </span>
          <h1 className="text-4xl font-bold text-navy-800">
            Conditions générales d'utilisation
          </h1>
          <p className="text-gray-400 text-sm mt-3">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <div className="prose prose-gray max-w-none">

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-navy-800 mb-4" id="article-1">
                <a href="#article-1" className="text-navy-800">Article 1 – Présentation de l'entreprise</a>
              </h2>
              <p className="text-gray-600 text-[16px] leading-relaxed mb-3">
                Le présent site internet est édité par :
              </p>
              <ul className="space-y-2 text-gray-600 text-[15px]">
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 rounded-sm bg-navy-800 mt-2 shrink-0 block" />
                  <span><strong>Nom :</strong> KRUTAK</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 rounded-sm bg-navy-800 mt-2 shrink-0 block" />
                  <span><strong>Dirigeante :</strong> Maria Ruta Krutak</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 rounded-sm bg-navy-800 mt-2 shrink-0 block" />
                  <span><strong>Statut :</strong> Entrepreneur individuel</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 rounded-sm bg-navy-800 mt-2 shrink-0 block" />
                  <span><strong>SIRET :</strong> 999 389 893 00010</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 rounded-sm bg-navy-800 mt-2 shrink-0 block" />
                  <span><strong>Adresse :</strong> 23 Rue Nationale, 59800 Lille, France</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 rounded-sm bg-navy-800 mt-2 shrink-0 block" />
                  <span><strong>Téléphone :</strong> +33 6 39 93 63 29</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 rounded-sm bg-navy-800 mt-2 shrink-0 block" />
                  <span><strong>Email :</strong> mariakrutak02@inbox.eu</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 rounded-sm bg-navy-800 mt-2 shrink-0 block" />
                  <span><strong>Code APE :</strong> 70.22Z – Conseil pour les affaires et autres conseils de gestion</span>
                </li>
              </ul>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-navy-800 mb-4" id="article-2">
                <a href="#article-2" className="text-navy-800">Article 2 – Objet du site</a>
              </h2>
              <p className="text-gray-600 text-[16px] leading-relaxed">
                Le présent site internet a pour objet de présenter les services de conseil en gestion et développement d'entreprise proposés par KRUTAK. Les informations publiées sont fournies à titre informatif et ne constituent pas une offre contractuelle.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-navy-800 mb-4" id="article-3">
                <a href="#article-3" className="text-navy-800">Article 3 – Conditions d'utilisation</a>
              </h2>
              <p className="text-gray-600 text-[16px] leading-relaxed mb-4">
                L'utilisation du présent site implique l'acceptation pleine et entière des conditions générales d'utilisation décrites ci-après. Ces conditions d'utilisation sont susceptibles d'être modifiées ou complétées à tout moment.
              </p>
              <p className="text-gray-600 text-[16px] leading-relaxed">
                L'utilisateur s'engage à utiliser le site de manière conforme à sa destination, à la législation en vigueur et aux présentes conditions.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-navy-800 mb-4" id="article-4">
                <a href="#article-4" className="text-navy-800">Article 4 – Propriété intellectuelle</a>
              </h2>
              <p className="text-gray-600 text-[16px] leading-relaxed">
                Tous les contenus présents sur le site (textes, images, logos, documents) sont protégés par le droit de la propriété intellectuelle. Toute reproduction, représentation ou diffusion, totale ou partielle, du contenu de ce site par quelque procédé que ce soit, sans l'autorisation expresse de KRUTAK, est interdite et constituerait une contrefaçon sanctionnée par les articles L. 335-2 et suivants du Code de la propriété intellectuelle.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-navy-800 mb-4" id="article-5">
                <a href="#article-5" className="text-navy-800">Article 5 – Limitation de responsabilité</a>
              </h2>
              <p className="text-gray-600 text-[16px] leading-relaxed">
                Les informations fournies sur ce site le sont à titre informatif. KRUTAK ne peut garantir l'exactitude, la complétude, l'actualité des informations diffusées sur le site. En conséquence, l'utilisateur reconnaît utiliser ces informations sous sa responsabilité exclusive.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-navy-800 mb-4" id="article-6">
                <a href="#article-6" className="text-navy-800">Article 6 – Droit applicable</a>
              </h2>
              <p className="text-gray-600 text-[16px] leading-relaxed">
                Les présentes conditions générales d'utilisation sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="text-2xl font-bold text-navy-800 mb-4" id="article-7">
                <a href="#article-7" className="text-navy-800">Article 7 – Contact</a>
              </h2>
              <p className="text-gray-600 text-[16px] leading-relaxed">
                Pour toute question relative aux présentes conditions, vous pouvez nous contacter à l'adresse suivante :{' '}
                <a href="mailto:mariakrutak02@inbox.eu" className="text-navy-700 underline cursor-pointer">
                  mariakrutak02@inbox.eu
                </a>
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
